export const STORE_LIBRARY_NAME = "library"

export const STATE_PLANT_ID = "plant_id"
export const STATE_PLANT_SETTINGS = "settings"
export const MUTATION_SET_PLANT = "setPlant"
export const MUTATION_SET_PLANT_SETTINGS = "setSettings"
export const ACTION_UPDATE_PLANT_SETTINGS = "updateSettings"
export const ACTION_SELECT_PLANT = "selectPlant"
export const ACTION_LEAVE_PLANT = "leavePlant"